import { createContext } from 'react';

import { SnackbarProps, SnackbarTransitionName } from '@hh.ru/magritte-ui-snackbar/types';

export interface SnackbarContextProps {
    animateIn: (uid: string, props: SnackbarProps) => void;
    animateOut: (
        uid: string,
        transition:
            | SnackbarTransitionName.Hide
            | SnackbarTransitionName.Autohide
            | SnackbarTransitionName.RemoveImmediately
    ) => void;
    isShown: (uid: string) => boolean;
    setContainerRef: (containerId: string, instance: HTMLElement | null) => void;
}

const noopFunc = (() => void 0) as VoidFunction;

export const SnackbarContext = createContext<SnackbarContextProps>({
    animateIn: noopFunc,
    animateOut: noopFunc,
    isShown: () => false,
    setContainerRef: noopFunc,
});
